import React, { FC } from "react";
import { useBookingSearch } from "./useBookingSearch";
import { LoadingAnimation } from "../LoadingAnimation/LoadingAnimation";
import { BookingButton } from "../BookingButton/BookingButton";
import { useForm } from "react-hook-form";
import {FormInput} from "../Form/FormInput";

interface BookingSearchForm {
  query: string;
}

export const BookingSearch: FC = () => {
  const { register, getValues, watch } = useForm<BookingSearchForm>({
    mode: "onBlur",
  });

  const query = watch("query");

  const { loading, bookingButtons } = useBookingSearch(query);

  return (
    <div className="mt-4">
      <FormInput
          registerReturn={register("query")}
          placeholder="Search"
          type="textbox"
          error={undefined}
          disabled={false}
      />
      {loading ? (
        <LoadingAnimation text="Loading search results" />
      ) : bookingButtons.length > 0 ? (
        <div className="body-text-container">
          <ul className="pipe-list ps-0 pt-1 mb-1 fw-normal">
            {bookingButtons.map((button, index) => (
              <li
                key={index}
                className="pipe-list__item doctor-offered-service"
              >
                <div>
                  <BookingButton
                    bookingButton={button}
                    cssClass="btn fw-normal p-0 remove-underline text-start"
                    labelCssClass="doctor-offered-treatments-booking-button"
                    ignorePersistedData={true}
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};
